export var MacroDebugStepType;
(function (MacroDebugStepType) {
    /**Step over the next instruction*/
    MacroDebugStepType["STEP_OVER"] = "STEP_OVER";
    /**Resume execution*/
    MacroDebugStepType["RESUME"] = "RESUME";
    /**Terminate execution*/
    MacroDebugStepType["TERMINATE"] = "TERMINATE";
    /**Step into the next macrvo call*/
    MacroDebugStepType["STEP_INTO"] = "STEP_INTO";
})(MacroDebugStepType || (MacroDebugStepType = {}));
export var TraceLevel;
(function (TraceLevel) {
    /**Debug (server-generated traces are DEBUG)*/
    TraceLevel["DEBUG"] = "DEBUG";
    /**Currently unused*/
    TraceLevel["ERROR"] = "ERROR";
    /**From the 'trace' keyword*/
    TraceLevel["TRACE"] = "TRACE";
    /**Currently unused*/
    TraceLevel["WARN"] = "WARN";
    /**Currently unused*/
    TraceLevel["INFO"] = "INFO";
})(TraceLevel || (TraceLevel = {}));
export var TraceType;
(function (TraceType) {
    /**A macro is starting*/
    TraceType["MS"] = "MS";
    /**A macro has ended*/
    TraceType["ME"] = "ME";
    /**User comment*/
    TraceType["CMT"] = "CMT";
    /**Developer-generated*/
    TraceType["USR"] = "USR";
})(TraceType || (TraceType = {}));
//# sourceMappingURL=MacroTypes.js.map